import React, { useState } from "react";

const API_URL = "https://api2.promotigo.com/api/Entries";
const LANGUAGE = "en"; // hardcoded language

export default function EntryForm() {
  const [form, setForm] = useState({
    formId: "",
    firstname: "",
    lastname: "",
    email: "",
    question1: "",
    question2: "",
    question3: "",
    optIn1: false,
  });
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: "", type: "" });

    try {
      const response = await fetch(
        `${API_URL}?FormId=${form.formId}&language=${LANGUAGE}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Firstname: form.firstname,
            Lastname: form.lastname,
            Email: form.email,
            EntryQuestion1: form.question1,
            EntryQuestion2: form.question2,
            EntryQuestion3: form.question3,
            OptIn1: form.optIn1,
          }),
        }
      );

      if (!response.ok) {
        if (response.type === "opaque") {
          setMessage({
            text: "CORS error: Unable to reach the API.",
            type: "error",
          });
          return;
        }
        const error = await response.json();
        setMessage({ text: error.message || "Submission failed.", type: "error" });
        return;
      }

      const data = await response.json();
      if (data.EntryId) {
        setMessage({
          text: `Success with ${data.EntryId}`,
          type: "success",
        });
      } else {
        setMessage({
          text: `Successful but response: ${JSON.stringify(data, null, 2)}`,
          type: "success",
        });
      }
    } catch (err) {
      if (err.message && err.message.includes("CORS")) {
        setMessage({
          text: "CORS error: Unable to reach the API.",
          type: "error",
        });
      } else {
        setMessage({ text: "Submission failed.", type: "error" });
      }
    }
  };

  return (
    <div className="container" style={{ maxWidth: 600, margin: "2rem auto" }}>
      {message.text && (
        <div
          className={`alert ${message.type === "success" ? "alert-success" : "alert-danger"}`}
          role="alert"
        >
          {message.text}
        </div>
      )}
      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        <div className="mb-3">
          <label htmlFor="formId" className="form-label">Form ID</label>
          <input
            id="formId"
            name="formId"
            className="form-control"
            placeholder="Form ID"
            value={form.formId}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="firstname" className="form-label">Firstname</label>
          <input
            id="firstname"
            name="firstname"
            className="form-control"
            placeholder="Firstname"
            value={form.firstname}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="lastname" className="form-label">Lastname</label>
          <input
            id="lastname"
            name="lastname"
            className="form-control"
            placeholder="Lastname"
            value={form.lastname}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input
            id="email"
            name="email"
            className="form-control"
            placeholder="Email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="question1" className="form-label">Entry Question 1</label>
          <input
            id="question1"
            name="question1"
            className="form-control"
            placeholder="Entry Question 1"
            value={form.question1}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="question2" className="form-label">Entry Question 2</label>
          <input
            id="question2"
            name="question2"
            className="form-control"
            placeholder="Entry Question 2"
            value={form.question2}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="question3" className="form-label">Entry Question 3</label>
          <input
            id="question3"
            name="question3"
            className="form-control"
            placeholder="Entry Question 3"
            value={form.question3}
            onChange={handleChange}
          />
        </div>
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="optIn1"
            name="optIn1"
            checked={form.optIn1}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="optIn1">
            OptIn1
          </label>
        </div>
        <button type="submit" className="btn btn-primary w-100">Submit</button>
      </form>
    </div>
  );
}
